import ContactUs from './ContactUs';
import Login from './Login';
// Coupons
import Coupons from './Coupons';
import EditCoupon from './Coupons/edit';
import AddCoupon from './Coupons/add';
// Stores
import Stores from './Stores';
import EditStore from './Stores/edit';
import AddStore from './Stores/add';
// Users
import Users from './Users';
import EditUser from './Users/edit';
import AddUser from './Users/add';
// Newsletter
import Newsletter from './Newsletter/index';
import Subscribers from './Subscribers/index';

// Logger
import LoggerSubscribers from './LoggerSubscribers/index';
import ShowCharts from './LoggerSubscribers/showCharts';

// Events
import Events from './Events';
import EditEvent from './Events/edit';
import AddEvent from './Events/add';

// Popular Stores
import PopularStores from './PopularStores';
import AddPopularStores from './PopularStores/add';

// Wall
import WallCoupons from './Wall';
import EditWall from './Wall/edit';

// Sliders
import Sliders from './Sliders';
import AddSlider from './Sliders/add';

// Work with us
import WorkWithUs from './WorkWithUs';

import Categories from './Categories/index';
import Subcategories from './Categories/subcategories';
import EditCategory from './Categories/edit';

// Application
import ApllicationHome from './Application/Home/index'

// BulkMessage (SMS)
import BulkMessages from './BulkMessage/index';
import AddBulkMessage from './BulkMessage/add';

// History (Change logs)
import History from './history/index';

// Comments
import Comments from './Comments/index';

// Pages
import Pages from './Pages/index';
import AddPage from './Pages/add';
import EditPage from './Pages/edit';

// Acl
import Roles from './ACL/roles';
import AddRole from './ACL/add_role';
import EditRole from './ACL/edit_role';

//Referral
import Referral from './Referral';
import EditReferral from './Referral/edit';

//Notifications
import Notifications from './Notification';
import AddNotification from './Notification/add';

// LuckyWheels
import LuckyWheels from './LuckyWheels';
import EditLuckyWheel from './LuckyWheels/edit';
import AddLuckyWheel from './LuckyWheels/add';
import LuckyWheelCoupons from './LuckyWheels/Coupons';
import EditLuckyWheelCoupon from './LuckyWheels/Coupons/edit';
import AddLuckyWheelCoupon from './LuckyWheels/Coupons/add';

//sale team
import SaleTeam from './SaleTeam';
import AddSaleTeam from './SaleTeam/add';

// Ads-modsl
import AdsModal from './AdsModal';
import AddAdsModal from './AdsModal/add';
import EditAdsModal from './AdsModal/edit';
import AdsChart from './AdsModal/showCharts';

//banner Header
import Banner from './Header';
import AddBanner from './Header/add';
import EditBanner from './Header/edit';
//Bread crumbs
import BreadCrumbs from './BreadCrumbs';
import AddBreadCrumbs from './BreadCrumbs/add';
import EditBreadCrumbs from './BreadCrumbs/edit';

import BrokenCoupons from './BrokenCoupons/index';
import AddTelegramMessage from './TelegramMessage/index'
export {
    Coupons,
    EditCoupon,
    AddCoupon,
    Stores,
    AddStore,
    EditStore,
    Users,
    EditUser,
    AddUser,
    ContactUs,
    Login,
    Newsletter,
    Subscribers,
    LoggerSubscribers,
    ShowCharts,
    Events,
    EditEvent,
    AddEvent,
    PopularStores,
    AddPopularStores,
    WallCoupons,
    EditWall,
    Sliders,
    AddSlider,
    WorkWithUs,
    Categories,
    Subcategories,
    EditCategory,
    ApllicationHome,

    BulkMessages,
    AddBulkMessage,

    History,

    Comments,
    Pages,
    AddPage,
    EditPage,

    Roles,
    AddRole,
    EditRole,
    Referral,
    EditReferral,
    Notifications,
    AddNotification,
    
    LuckyWheels,
    AddLuckyWheel,
    EditLuckyWheel,
    LuckyWheelCoupons,
    AddLuckyWheelCoupon,
    EditLuckyWheelCoupon,
    SaleTeam,
    AddSaleTeam,
    AdsModal,
    AddAdsModal,
    EditAdsModal,
    AdsChart,
    Banner,
    AddBanner,
    EditBanner,
    BrokenCoupons,
    AddTelegramMessage,

    AddBreadCrumbs,
    EditBreadCrumbs,
    BreadCrumbs
};


// WEBPACK FOOTER //
// ./src/containers/index.js